module.exports = __webpack_public_path__ + "img/icon-energy-oven.d27cc50f.svg";